export const buildReport = section => {
  let report = {
    section: section,
    label: null,
  }

  switch (section) {
    case "session_report":
      report.label = "Session Report"
      break
    case "active_users":
      report.label = "Active Users"
      break
    case "device_report":
      report.label = "Device Report"
      break
    case "users_report":
      report.label = "Users Report"
      break
    case "exp_report":
      report.label = "Experiences Report"
      break
    case "ad_report":
      report.label = "Ad Reports"
      break
    case "booking_transactions":
      report.label = "Booking Transactions"
      break
    case "products_subscriprions_transactions":
      report.label = "Products & Subscriptions Transactions"
      break
    case "form_builder_transactions":
      report.label = "Form Builder Transactions"
      break

    default:
      report = null
      break
  }
  return report
}

export const sortDatesForChart = (data, type) => {
  let arr = [...data]
  switch (type) {
    case "year":
      return arr.sort((d1, d2) => {
        const [m1, y1] = d1?.date.split("-")
        const [m2, y2] = d2?.date.split("-")
        if (y1 < y2) {
          return -1
        }
        if (y1 > y2) {
          return 1
        }
        if (y1 === y2) {
          return m1 < m2 ? -1 : 1
        }

        return 0
      })
    case "month":
    case "week":
      return arr.sort((d1, d2) => {
        const date1 = new Date(d1?.date).getTime()
        const date2 = new Date(d2?.date).getTime()
        if (date1 < date2) {
          return -1
        }
        if (date1 > date2) {
          return 1
        }
        return 0
      })
    case "day":
      return arr.sort((d1, d2) => {
        const date1 = new Date(`${d1?.date}:00`).getTime()
        const date2 = new Date(`${d2?.date}:00`).getTime()
        if (date1 < date2) {
          return -1
        }
        if (date1 > date2) {
          return 1
        }
        return 0
      })
    default:
      return arr
  }
}

export const prepareDataForUsersChart = (activeUsers, newUsers, type) => {
  const data = []
  const dates = newUsers?.reduce(
    (acc, item) => (acc?.includes(item?.date) ? acc : [...acc, item?.date]),
    activeUsers?.map(item => item?.date)
  )
  for (const date of dates) {
    const active_users = activeUsers?.find(x => x.date === date)
    const new_users = newUsers?.find(x => x.date === date)
    data.push({
      date: date,
      active_users: active_users
        ? active_users?.total_accounts + active_users?.total_guests
        : 0,
      new_users: new_users ? new_users?.total_accounts : 0,
    })
  }
  return sortDatesForChart(data, type)
}
